import type { JSX } from '@builder.io/qwik';
import { useContextProvider } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import {
  getCSSColorBg,
  getCSSHeightLgFactor,
  getCSSHeightSmFactor,
} from '~/utilities/getCSS';
import Nav from '~/components/Layout/Header/Desktop/Nav';
import { NavContext } from '~/contexts/NavContext';
import { SI_TOP_NAV_THEME } from '~/constants/SI_TOP_NAV_THEME';

const headerClasses = cva(
  'fixed flex items-center space-between w-full px-4 z-40 top-0 [&_a]:text-[14px]',
  {
    variants: {
      color: getCSSColorBg(),
      heightSm: getCSSHeightSmFactor(),
      heightLg: getCSSHeightLgFactor(),
    },
  }
);

export default component$((): JSX.Element => {
  const {
    payloadToSSR: {
      layout: { header },
    },
  } = useContext(AppDataContext);

  if (!header.links?.value.length) return <></>;

  // SI Header is not built with the theming tool, so we need to hardcode these values
  const navTheme = SI_TOP_NAV_THEME;

  useContextProvider(NavContext, {
    header: header,
    theme: navTheme,
    hasAccessibility: false,
    navInMobile: true,
    canHaveMore: false,
    maskImage: 'si',
  });

  return (
    <div
      class={headerClasses({
        color: navTheme.BackgroundColor.value,
        heightSm: navTheme.HeightInSmallScreen.value,
        heightLg: navTheme.HeightInLargeScreen.value,
      })}
    >
      <Nav />
    </div>
  );
});
